import { formatDateDisplay, generateLinkImage, stripHTML } from "./helpers";
import { ListType } from "../types/list.type";
import ExpandUsergroup from "../components/common/expand/usergroup/ExpandUsegroup";
import FilterUserGroup from "../components/common/filters/usergroup/FilterUserGroup";
import FormUsergroup from "../components/common/form/usergroup/FormUsergroup";
import CheckboxInput from "../components/common/input/CheckboxInput";
import FormParticipant from "../components/common/form/participant/FormParticipant";
import FilterParticipant from "../components/common/filters/participant/FilterParticipant";
import ExpandFeed from "../components/common/expand/feed/ExpandFeed";
import FilterFeed from "../components/common/filters/feed/FilterFeed";
import ExpandForum from "../components/common/expand/forum/ExpandForum";
import FilterForum from "../components/common/filters/forum/FilterForum";
import ExpandCommentFeed from "../components/common/expand/comment-feed/ExpandCommentFeed";
import FilterFeedComment from "../components/common/filters/feed-comment/FilterFeedComment";
import FilterForumComment from "../components/common/filters/forum-comment/FilterForumComment";
import ExpandCommentForum from "../components/common/expand/comment-forum/ExpandCommentForum";
import { Avatar, Typography } from "@mui/material";
import FilterBanner from "../components/common/filters/banner/FilterBanner";
import FilterComplaint from "../components/common/filters/complaint/FilterComplaint";
import FilterReportList from "../components/common/filters/reportlist/FilterReportList";
import FilterSocialCategory from "../components/common/filters/socialcategory/FilterSocialCatetory";
import FormSocialCategory from "../components/common/form/socialcategory/FormSocialCategory";
import FormTopic from "../components/common/form/topic/FormTopic";
import FilterTopic from "../components/common/filters/topic/FilterTopic";
import FormForumPost from "../components/common/form/forumpost/FormForumPost";
import CheckboxUpdate from "../components/common/fast-update/CheckboxUpdate";
import FormHashtag from "../components/common/form/hashtag/FormHashtag";
import FilterHashtag from "../components/common/filters/hashtag/FilterHashtag";
import FormQuote from "../components/common/form/quote/FormQuote";
import FormComment from "../components/common/form/comment/FormComment";
import FormFeed from "../components/common/form/feed/FormFeed";
import FormComplaintGroup from "../components/common/form/complaint-group/FormComplaintGroup";
import FilterComplaintGroup from "../components/common/filters/complaint-group/FilterComplaintGroup";
import FormComplaint from "../components/common/form/complaint/FormComplaint";
import ExpandComplaint from "../components/common/expand/complaint/ExpandComplaint";
import FormLogo from "../components/common/form/logo/FormLogo";
import FormReportList from "../components/common/form/reportlist/FormReportList";
import ModalViewFeed from "../components/common/modal/ModalViewFeed";
import FormBannerFeed from "../components/common/form/banner-feed/FormBannerFeed";
import FilterBannerFeed from "../components/common/filters/banner_feed/FilterBannerFeed";
import FormBannerForum from "../components/common/form/banner-forum/FormBannerForum";
import {
  BANNER_FEED_POSTION_OPTIONS,
  BANNER_FORUM_POSTION_OPTIONS,
} from "./ui.constants";
import FilterBannerForum from "../components/common/filters/banner_forum/FilterBannerForum";
import ExpandSocialCategory from "../components/common/expand/socialcategory/ExpandSocialCategory";

const lists: { [key: string]: ListType } = {
  usergroup: {
    apiCode: "usergroup",
    title: "Nhóm người dùng",
    formTitle: "Nhóm người dùng",
    fields: [{ value: "group_name", label: "Tên nhóm" }],
    allowCreate: true,
    Expand: ExpandUsergroup,
    Filter: FilterUserGroup,
    Form: FormUsergroup,
    columns: [
      {
        name: "Tên nhóm",
        width: "200px",
        wrap: true,
        selector: (row) => row.group_name,
      },
    ],
  },
  participant: {
    apiCode: "participant",
    title: "Người dùng",
    formTitle: "người dùng",
    allowCreate: true,
    fields: [
      { value: "email", label: "Tài khoản" },
      { value: "name", label: "Tên" },
    ],
    Filter: FilterParticipant,
    Form: FormParticipant,
    columns: [
      {
        name: "Tài khoản",
        width: "200px",
        wrap: true,
        selector: (row) => row.email,
      },
      {
        name: "Tên",
        width: "200px",
        wrap: true,
        selector: (row) => row.name,
      },
      {
        name: "Nhóm",
        width: "140px",
        wrap: true,
        selector: (row) => row.group_name,
      },
      {
        name: "Cấp thành viên",
        width: "140px",
        wrap: true,
        center: true,
        selector: (row) => row.level || 1,
      },
      {
        name: "Ghi chú",
        width: "200px",
        wrap: true,
        selector: (row) => row.dien_giai,
      },
      {
        name: "Quản trị viên",
        width: "120px",
        selector: (row) => row.admin,
        cell: (row) => {
          return (
            <CheckboxUpdate
              idUpdate={row?._id}
              defaultChecked={row?.admin}
              apiCode="participant"
              fieldUpdate="admin"
            />
          );
        },
      },
      {
        name: "Khóa",
        width: "80px",
        selector: (row) => row.cancel,
        cell: (row) => {
          return (
            <CheckboxUpdate
              idUpdate={row?._id}
              defaultChecked={row?.cancel}
              apiCode="participant"
              fieldUpdate="cancel"
            />
          );
        },
      },
      {
        name: "Hoạt động",
        width: "100px",
        selector: (row) => row.status,
        cell: (row) => {
          return (
            <CheckboxUpdate
              idUpdate={row?._id}
              defaultChecked={row?.status}
              apiCode="participant"
              fieldUpdate="status"
            />
          );
        },
      },
    ],
  },
  posts: {
    apiCode: "posts",
    title: "Danh sách bài feed",
    allowCreate: true,
    Expand: ExpandFeed,
    Filter: FilterFeed,
    Form: FormFeed,
    columns: [
      {
        name: "Nổi bật",
        width: "80px",
        selector: (row) => row.isPopular,
        cell: (row) => {
          return (
            <CheckboxUpdate
              idUpdate={row?._id}
              defaultChecked={row?.isPopular}
              apiCode="posts"
              fieldUpdate="isPopular"
            />
          );
        },
      },
      {
        name: "Người đăng",
        width: "150px",
        wrap: true,
        selector: (row) => row.user_created,
      },
      {
        name: "Tên người đăng",
        width: "150px",
        wrap: true,
        selector: (row) => row.name_user_created,
      },
      {
        name: "Ngày tạo",
        width: "150px",
        wrap: true,
        selector: (row) => row.date_created,
        format: (row) =>
          formatDateDisplay(row.date_created, "HH:mm DD/MM/YYYY"),
      },
      {
        name: "Chế độ",
        width: "120px",
        wrap: true,
        selector: (row) => row.mode,
        cell: (row) => {
          if (row.mode === "private") {
            return "Chỉ mình tôi";
          } else if (row.mode === "friends") {
            return "Bạn bè";
          } else if (row.mode === "anonymous") {
            return "Ẩn danh";
          } else {
            return "Công khai";
          }
        },
      },
      {
        name: "Lượt xem",
        width: "100px",
        wrap: true,
        right: true,
        selector: (row) => row.viewCount,
      },
      {
        name: "Lượt thích",
        width: "100px",
        wrap: true,
        right: true,
        selector: (row) => row.likeCount,
      },
      {
        name: "Lượt comment",
        width: "150px",
        wrap: true,
        right: true,
        selector: (row) => row.commentCount,
      },
      {
        name: "Nội dung",
        width: "200px",
        selector: (row) => row.description,
        format: (row) => stripHTML(row.description),
      },
    ],
  },
  forumposts: {
    apiCode: "forumposts",
    title: "Danh sách bài forum",
    allowCreate: true,
    Expand: ExpandForum,
    Filter: FilterForum,
    Form: FormForumPost,
    columns: [
      {
        name: "Nổi bật",
        width: "80px",
        selector: (row) => row.isPopular,
        cell: (row) => {
          return (
            <CheckboxUpdate
              idUpdate={row?._id}
              defaultChecked={row?.isPopular}
              apiCode="forumposts"
              fieldUpdate="isPopular"
            />
          );
        },
      },
      {
        name: "Người đăng",
        width: "150px",
        wrap: true,
        selector: (row) => row.user_created,
      },
      {
        name: "Tên người đăng",
        width: "150px",
        wrap: true,
        selector: (row) => row.name_user_created,
      },
      {
        name: "Ngày tạo",
        width: "150px",
        wrap: true,
        selector: (row) => row.date_created,
        format: (row) =>
          formatDateDisplay(row.date_created, "HH:mm DD/MM/YYYY"),
      },
      {
        name: "Chủ đề",
        width: "130px",
        wrap: true,
        selector: (row) => row.topic_name,
      },
      {
        name: "Danh mục",
        width: "130px",
        wrap: true,
        selector: (row) => row.category_name,
      },
      {
        name: "Tiêu đề",
        width: "200px",
        selector: (row) => row.title,
        format: (row) => stripHTML(row.title),
      },
      {
        name: "Slug",
        width: "200px",
        selector: (row) => row.slug,
        format: (row) => stripHTML(row.slug),
      },
      {
        name: "Lượt thích",
        width: "100px",
        wrap: true,
        right: true,
        selector: (row) => row.likeCount,
      },
      {
        name: "Lượt comment",
        width: "150px",
        wrap: true,
        right: true,
        selector: (row) => row.commentCount,
      },
    ],
  },
  socialcategories: {
    apiCode: "socialcategories",
    title: "Danh mục forum",
    allowCreate: true,
    condition: { parentId: { $in: ["", null] } },
    query: { sort: { no: 1 } },
    Form: FormSocialCategory,
    Filter: FilterSocialCategory,
    Expand: ExpandSocialCategory,
    columns: [
      {
        name: "Hiển thị",
        width: "100px",
        selector: (row) => row.status,
        cell: (row) => {
          return (
            <CheckboxUpdate
              idUpdate={row?._id}
              defaultChecked={row?.status}
              apiCode="socialcategories"
              fieldUpdate="status"
            />
          );
        },
      },
      {
        name: "STT",
        width: "80px",
        wrap: true,
        selector: (row) => row.no,
      },
      {
        name: "Tên",
        width: "200px",
        wrap: true,
        selector: (row) => row.name,
      },
      {
        name: "Slug",
        width: "200px",
        wrap: true,
        selector: (row) => row.slug,
      },
      {
        name: "Mô tả",
        width: "200px",
        wrap: true,
        selector: (row) => row?.exfields?.subscription,
      },
      {
        name: "SL bài",
        width: "120px",
        right: true,
        selector: (row) => row.post_count,
      },
      {
        name: "Lượt thích",
        width: "120px",
        right: true,
        selector: (row) => row.like_count,
      },
      {
        name: "Lượt comment",
        width: "130px",
        right: true,
        selector: (row) => row.comment_count,
      },
    ],
  },
  topic: {
    apiCode: "topics",
    title: "Chủ đề",
    allowCreate: true,
    Form: FormTopic,
    Filter: FilterTopic,
    columns: [
      {
        name: "Tên",
        width: "200px",
        wrap: true,
        selector: (row) => row.name,
      },
      {
        name: "Ghi chú",
        width: "200px",
        wrap: true,
        selector: (row) => row.exfields?.dien_giai,
      },
    ],
  },
  socialcomment: {
    apiCode: "socialcomment",
    title: "Bình luận feed",
    condition: { kind: "post" },
    allowCreate: true,
    Expand: ExpandCommentFeed,
    Filter: FilterFeedComment,
    Form: FormComment,
    columns: [
      {
        name: "Người tạo",
        width: "150px",
        wrap: true,
        selector: (row) => row.user_created,
      },
      {
        name: "Tên người tạo",
        width: "150px",
        wrap: true,
        selector: (row) => row.name_user_created,
      },
      {
        name: "Thời gian",
        width: "150px",
        wrap: true,
        selector: (row) => row.date_created,
        format: (row) =>
          formatDateDisplay(row.date_created, "HH:mm DD/MM/YYYY"),
      },
      {
        name: "Nội dung",
        width: "200px",
        selector: (row) => row.content,
      },
      {
        name: "Là con",
        width: "120px",
        wrap: true,
        selector: (row) => row.replyId,
        cell: (row) => {
          return <CheckboxInput readOnly checked={!!row.replyId} />;
        },
      },
    ],
  },
  quote: {
    apiCode: "socialcomment",
    title: "Bình luận forum",
    condition: { kind: "forum" },
    allowCreate: true,
    Form: FormQuote,
    Expand: ExpandCommentForum,
    Filter: FilterForumComment,
    columns: [
      {
        name: "Người tạo",
        width: "150px",
        wrap: true,
        selector: (row) => row.user_created,
      },
      {
        name: "Tên người tạo",
        width: "150px",
        wrap: true,
        selector: (row) => row.name_user_created,
      },
      {
        name: "Thời gian",
        width: "150px",
        wrap: true,
        selector: (row) => row.date_created,
        format: (row) =>
          formatDateDisplay(row.date_created, "HH:mm DD/MM/YYYY"),
      },
      {
        name: "Nội dung",
        width: "200px",
        selector: (row) => row.content,
      },
      {
        name: "Trích dẫn",
        width: "200px",
        wrap: true,
        selector: (row) => row.qouteContent,
      },
    ],
  },
  logo: {
    apiCode: "banner",
    title: "Logo",
    allowCreate: true,
    condition: { "exfields.type": "logo" },
    Form: FormLogo,
    Filter: FilterBanner,
    columns: [
      {
        name: "Hiển thị",
        width: "120px",
        selector: (row) => row.status,
        cell: (row) => {
          return (
            <CheckboxUpdate
              idUpdate={row?._id}
              defaultChecked={row?.status}
              apiCode="banner"
              fieldUpdate="status"
            />
          );
        },
      },
      {
        name: "Ưu tiên",
        selector: (row) => row.exfields?.stt,
        width: "80px",
      },
      {
        name: "Tiêu đề",
        width: "120px",
        wrap: true,
        selector: (row) => row.tieu_de,
      },
      {
        name: "Từ ngày",
        width: "140px",
        selector: (row) => row?.exfields?.start_date,
        format: (row) => formatDateDisplay(row?.exfields?.start_date),
      },
      {
        name: "Đến ngày",
        width: "140px",
        selector: (row) => row?.exfields?.end_date,
        format: (row) => formatDateDisplay(row?.exfields?.end_date),
      },
      {
        name: "Hình ảnh",
        wrap: true,
        selector: (row) => row.hinh_anh,
        cell: (row) => {
          return (
            <Avatar
              src={row.hinh_anh ? generateLinkImage(row.hinh_anh) : ""}
              alt="banner image"
              sx={{ borderRadius: "0px", width: "90px", height: "30px" }}
            />
          );
        },
      },
      {
        name: "Ghi chú",
        width: "200px",
        selector: (row) => row.mo_ta || "",
      },
    ],
  },
  banner_feed: {
    apiCode: "banner",
    title: "Banner Feed",
    allowCreate: true,
    condition: {
      'exfields.type': 'feed',
    },
    Form: FormBannerFeed,
    Filter: FilterBannerFeed,
    columns: [
      {
        name: "Hiển thị",
        width: "120px",
        selector: (row) => row.status,
        cell: (row) => {
          return (
            <CheckboxUpdate
              idUpdate={row?._id}
              defaultChecked={row?.status}
              apiCode="banner"
              fieldUpdate="status"
            />
          );
        },
      },
      {
        name: "STT",
        selector: (row) => row.exfields?.stt,
        width: "80px",
      },
      {
        name: "Tiêu đề",
        width: "150px",
        wrap: true,
        selector: (row) => row.tieu_de,
      },
      {
        name: "Vị trí",
        width: "120px",
        selector: (row) => row.exfields?.position,
        format: (row) => {
          return BANNER_FEED_POSTION_OPTIONS.find(
            (item) => item.value === row.exfields?.position
          )?.label;
        },
      },
      {
        name: "Từ ngày",
        width: "140px",
        selector: (row) => row?.exfields?.start_date,
        format: (row) => formatDateDisplay(row?.exfields?.start_date),
      },
      {
        name: "Đến ngày",
        width: "140px",
        selector: (row) => row?.exfields?.end_date,
        format: (row) => formatDateDisplay(row?.exfields?.end_date),
      },
      {
        name: "Liên kết",
        selector: (row) => row.exfields?.link,
        width: "150px",
      },
      {
        name: "Ghi chú",
        width: "200px",
        wrap: true,
        selector: (row) => row.mo_ta,
      },
      {
        name: "Hình ảnh",
        wrap: true,
        selector: (row) => row.hinh_anh,
        cell: (row) => {
          return (
            <Avatar
              src={row.hinh_anh ? generateLinkImage(row.hinh_anh) : ""}
              alt="banner image"
              sx={{ borderRadius: "0px", width: "90px", height: "30px" }}
            />
          );
        },
      },
    ],
  },
  banner_forum: {
    apiCode: "banner",
    title: "Banner Forum",
    allowCreate: true,
    condition: {
      'exfields.type': 'forum',
    },
    Form: FormBannerForum,
    Filter: FilterBannerForum,
    columns: [
      {
        name: "Hiển thị",
        width: "120px",
        selector: (row) => row.status,
        cell: (row) => {
          return (
            <CheckboxUpdate
              idUpdate={row?._id}
              defaultChecked={row?.status}
              apiCode="banner"
              fieldUpdate="status"
            />
          );
        },
      },
      {
        name: "STT",
        selector: (row) => row.exfields?.stt,
        width: "80px",
      },
      {
        name: "Tiêu đề",
        width: "150px",
        wrap: true,
        selector: (row) => row.tieu_de,
      },
      {
        name: "Vị trí",
        width: "120px",
        selector: (row) => row.exfields?.position,
        format: (row) => {
          return BANNER_FORUM_POSTION_OPTIONS.find(
            (item) => item.value === row.exfields?.position
          )?.label;
        },
      },
      {
        name: "Từ ngày",
        width: "140px",
        selector: (row) => row?.exfields?.start_date,
        format: (row) => formatDateDisplay(row?.exfields?.start_date),
      },
      {
        name: "Đến ngày",
        width: "140px",
        selector: (row) => row?.exfields?.end_date,
        format: (row) => formatDateDisplay(row?.exfields?.end_date),
      },
      {
        name: "Liên kết",
        selector: (row) => row.exfields?.link,
        width: "150px",
      },
      {
        name: "Ghi chú",
        width: "200px",
        wrap: true,
        selector: (row) => row.mo_ta,
      },
      {
        name: "Hình ảnh",
        wrap: true,
        selector: (row) => row.hinh_anh,
        cell: (row) => {
          return (
            <Avatar
              src={row.hinh_anh ? generateLinkImage(row.hinh_anh) : ""}
              alt="banner image"
              sx={{ borderRadius: "0px", width: "90px", height: "30px" }}
            />
          );
        },
      },
    ],
  },

  complaint: {
    apiCode: "comment2",
    title: "Liên hệ",
    allowCreate: true,
    condition: { parent: { $in: ["", null] } },
    Filter: FilterComplaint,
    Form: FormComplaint,
    Expand: ExpandComplaint,
    columns: [
      {
        name: "Trạng thái",
        width: "150px",
        wrap: true,
        selector: (row) => row.ten_trang_thai,
        cell: (row) => {
          return (
            <Typography sx={{ color: row.color }}>
              {row.ten_trang_thai}
            </Typography>
          );
        },
      },
      {
        name: "Loại liên hệ",
        width: "150px",
        wrap: true,
        selector: (row) => row.of_name,
      },
      {
        name: "Nội dung",
        width: "200px",
        wrap: true,
        selector: (row) => row.content,
      },
      {
        name: "Ngày tạo",
        width: "150px",
        wrap: true,
        selector: (row) => row.date_created,
        format: (row) =>
          formatDateDisplay(row.date_created, "DD/MM/YYYY HH:mm"),
      },
    ],
  },
  complaint_group: {
    apiCode: "group",
    title: "Nhóm liên hệ",
    allowCreate: true,
    condition: { group_type: "COMPLAINT" },
    Form: FormComplaintGroup,
    Filter: FilterComplaintGroup,
    columns: [
      {
        name: "Tên nhóm",
        selector: (row) => row.group_name,
      },
    ],
  },
  reportlist: {
    apiCode: "reportlist",
    title: "Tố cáo bài viết",
    Filter: FilterReportList,
    Form: FormReportList,
    allowCreate: true,
    columns: [
      {
        name: "",
        width: "150px",
        cell: (row) => {
          return <ModalViewFeed postId={row?.postid} />;
        },
      },
      {
        name: "Trạng thái",
        width: "150px",
        wrap: true,
        selector: (row) => row.ten_trang_thai,
        cell: (row) => {
          return (
            <Typography sx={{ color: row.color }}>
              {row.ten_trang_thai}
            </Typography>
          );
        },
      },
      {
        name: "Tiêu đề",
        width: "200px",
        wrap: true,
        selector: (row) => row.title,
      },
      {
        name: "Nội dung",
        width: "200px",
        wrap: true,
        selector: (row) => row.content,
      },
      {
        name: "Ghi chú",
        width: "200px",
        wrap: true,
        selector: (row) => row.exfields?.dien_giai,
      },
    ],
  },
  hashtags: {
    apiCode: "hashtags",
    title: "Hashtag",
    allowCreate: true,
    query: { sort: { "exfields.stt": 1 } },
    Form: FormHashtag,
    Filter: FilterHashtag,
    columns: [
      {
        name: "Hiển thị",
        width: "100px",
        selector: (row) => row.status,
        cell: (row) => {
          return (
            <CheckboxUpdate
              idUpdate={row?._id}
              defaultChecked={row?.status}
              apiCode="hashtags"
              fieldUpdate="status"
            />
          );
        },
      },
      {
        name: "STT",
        width: "80px",
        wrap: true,
        selector: (row) => row.exfields?.stt || "1",
      },
      {
        name: "Tên",
        width: "200px",
        wrap: true,
        selector: (row) => row.name,
      },
      {
        name: "Lượt dùng",
        width: "150px",
        wrap: true,
        selector: (row) => row.count,
      },
      {
        name: "Ghi chú",
        width: "200px",
        wrap: true,
        selector: (row) => row.exfields?.dien_giai,
      },
    ],
  },
};

export { lists };
